const attributesKey = attributes =>
  JSON.stringify(
    (attributes || []).map(({ key, value }) => [key, value]).sort((a, b) => (a[0] < b[0] ? -1 : 1))
  );

export default function mergeDisplayLines(edges) {
  const byKey = new Map();
  const out = [];
  (edges || []).forEach(({ node }) => {
    const variantId = node?.merchandise?.id;
    if (!variantId) {
      out.push({ node });
      return;
    }
    const key = [
      variantId,
      node.sellingPlanAllocation?.sellingPlan?.id || '',
      attributesKey(node.attributes),
    ].join('|');
    const existing = byKey.get(key);
    if (!existing) {
      const copy = { node: { ...node } };
      byKey.set(key, copy);
      out.push(copy);
      return;
    }
    existing.node.quantity += node.quantity;
    existing.node.discountAllocations = [
      ...(existing.node.discountAllocations || []),
      ...(node.discountAllocations || []),
    ];
    existing.node.extraLines = [...(existing.node.extraLines || []), { id: node.id, variantId }];
  });
  return out;
}
